module.exports = __webpack_public_path__ + "static/media/banner-cel-mobile.0e9705b0.png";